import { render, staticRenderFns } from "./ModelOfSell.vue?vue&type=template&id=b5dceb00&scoped=true"
import script from "./ModelOfSell.vue?vue&type=script&lang=js"
export * from "./ModelOfSell.vue?vue&type=script&lang=js"
import style0 from "./ModelOfSell.vue?vue&type=style&index=0&id=b5dceb00&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5dceb00",
  null
  
)

export default component.exports